export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    mobile: 600,
    tablet: 960,
    laptop: 1440,
    desktop: 1920,
  },
};
